<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="4">
          <v-select
            :items="categories"
            label="Select Category"
            v-model="selectedCategory"
          ></v-select>
        </v-col>

        <v-col cols="4">
          <v-text-field
            label="Description"
            v-model="description"
          ></v-text-field>
        </v-col>

        <v-col cols="4">
          <v-text-field label="Amount" v-model="amount"></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col cols="4"> </v-col>

        <v-col cols="4">
          <v-btn
            large
            outlined
            :color="getOutlineColor"
            rounded
            @click="submitEarningsAndDeductions()"
            >Submit Data</v-btn
          >
        </v-col>

        <v-col cols="4"> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: ["employeesIDs", "payrollID"],
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data: () => ({
    amount: 0,
    selectedCategory: null,
    description: null,
    categories: ["Other Earnings", "Deductions"],
  }),
  methods: {
    submitEarningsAndDeductions() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/submit-earnings-and-deductions",
          {
            amount: this.amount,
            selectedCategory: this.selectedCategory,
            description: this.description,
            employeesIDs: this.employeesIDs,
            payrollID: this.payrollID,
          },
          this.getAccessToken
        )
        .then((payrolls) => {
          this.$emit("earnings-and-deductions-created", payrolls);
          this.$store.commit("setLoader", false);
        });
    },
  },
};
</script>

<style></style>
